<template>
	<div class="notice">
		<div class="notice-text">
			<slot></slot>
		</div>
		<div class="notice-action" @click="onClick">
			<slot name="action">刷新</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'dbNotice',
	methods: {
		onClick() {
			this.$emit('refresh');
		}
	}
};
</script>

<style scoped lang="scss">
	.notice {
		width: 100%;
		min-height: 42px;
		background: #FFF1F0;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 9px 16px;

		&-text {
			flex: 1;
			font-size: 13px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FF3B30;
			line-height: 20px;
		}

		&-action {
			width: 47px;
			height: 23px;
			line-height: 23px;
			background: #FF3B30;
			border-radius: 4px;
			font-size: 11px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
			text-align: center;
			flex-shrink: 0;
		}
	}
</style>
